import { SearchPredicate } from '@nx-smartmonkey/shared/domain';
import { ServiceResponse } from '@nx-smartmonkey/shared/hooks';
import { PaginatedResult } from '@nx-smartmonkey/shared/interfaces';
import { useQuery } from '@tanstack/react-query';
import { searchRoutesMutationKey } from '.';
import { capacitorService } from '../../../../application/CapacitorService';
import { routeService } from '../../../../application/RouteService';
import { Route } from '../../../../domain/route/Route';

interface UseSearchRoutesProps {
  startDay: Date;
  endDay: Date;
  offset?: number;
  limit?: number;
}
type UseSearchRoutesResponseProps = ServiceResponse<Function, PaginatedResult<Route>>;

export const useSearchRoutes = ({
  startDay,
  endDay,
  offset = 0,
  limit = 25,
}: UseSearchRoutesProps): UseSearchRoutesResponseProps => {
  const { isInitialLoading, isSuccess, isError, refetch, isRefetching, data } = useQuery(
    searchRoutesMutationKey({
      future: false,
      offset,
      limit,
      sort_by: `plan_execution_date`,
      sort_direction: `desc`,
    }),
    () =>
      routeService.searchRoutes({
        offset,
        limit,
        sort_by: `plan_execution_date`,
        sort_direction: `desc`,
        predicates: [
          SearchPredicate.create({
            field: `plan_execution_date`,
            operator: `gte`,
            type: `date`,
            value: startDay,
          }),
          SearchPredicate.create({
            field: `plan_execution_date`,
            operator: `lte`,
            type: `date`,
            value: endDay,
          }),
        ],
      }),
    {
      retry: false,
      enabled: true,
      refetchOnWindowFocus: capacitorService.isNative(),
    }
  );
  return {
    error: isError,
    success: isSuccess,
    isLoading: isRefetching || isInitialLoading,
    data,
    run: refetch,
  };
};
